<div mat-dialog-title class="dialog-title p-3 pr-5">
  <h5> Clone Form Structure</h5>
  <button
    mat-icon-button
    aria-label="Close dialog"
    matTooltip="Close this dialog."
    (click)="onClose()"
    class="dialog-close-button">
    <mat-icon>close</mat-icon>
  </button>
</div>

<hr class="m-0 p-0">

<form #f="ngForm" (ngSubmit)="onSubmit(f)">

  <mat-dialog-content class="px-3 py-4">

    <mat-form-field class="full-width mb-3" appearance="outline">
      <mat-label>Form Title</mat-label>
      <input
        matInput
        placeholder="Form Title"
        [(ngModel)]="clone_data.form_title"
        name="form_title"
        type="text"
        id="form_title"
        required />
      <mat-hint>Please review and/or enter a new form title.</mat-hint>
    </mat-form-field>

    <mat-form-field class="full-width mb-3" appearance="outline">
      <mat-label>Form Description</mat-label>
      <textarea
        matInput
        placeholder="Form Description"
        [(ngModel)]="clone_data.form_description"
        name="form_description"
        type="text"
        id="form_description"
        rows="3"
        required>
      </textarea>
      <mat-hint>Please review and/or enter a new form description.</mat-hint>
    </mat-form-field>

  </mat-dialog-content>

  <hr class="m-0 p-0">

  <mat-dialog-actions class="d-flex justify-content-end px-3 py-1">
    <button
      class="m-1"
      mat-raised-button
      [disabled]="!f.valid"
      type="button"
      color="primary"
      (click)="onSubmit(f)">
      <mat-icon>save</mat-icon> Clone Form
    </button>
  </mat-dialog-actions>

</form>

